module.exports = __webpack_public_path__ + "img/join-btn.c2241a6c.png";